import React, { useState, useEffect, useCallback } from "react";
import './../Maintenance/Maintenance.css';
import { CreateButton } from '../CommonObjects';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { GeneralMessage, useGeneralMessage } from '../../common/APICommon';
import { CreateTable } from '../ManageTable';
import { token, domain } from '../Security';
// icon
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import { LoadingSpinner } from "../../common/Loading";
import { DateTimeInput } from "../../common/Input";
// Enums
import { IdentifierSelect } from "../../common/selectComponents/IdentifierSelect";
import { YearSelect } from "../../common/selectComponents/YearSelect";
import { StatusSelect } from "../../common/selectComponents/StatusSelect";
import { PayTypeSelect } from "../../common/selectComponents/PayTypeSelect";

function PayrollPeriod({ user, isHideSideMenu }) {
  var header = [
    "ID",
    "Pay Type",
    "Identifier", 
    "Date From",
    "Date To",
    "Status",
    // "Is Posted Time Keeping?",
    // "Is Posted Payroll?",
    "",
  ]
  var accessor = [
    "id",
    "payTypeDescription",
    "identifier", 
    "dateFrom",
    "dateTo",
    "isActive",
    // "timeKeepingFlg",
    // "payrollFlg",
    "manage"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [payrollPeriod, setPayrollPeriod] = useState([]);
  const [originalPayrollPeriod, setOriginalPayrollPeriod] = useState([]);

  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  // CHANGED: Initialize as empty string so no default is selected
  const [identifier, setIdentifier] = useState(""); 
  const [timeKeepingFlg, setTimeKeepingFlg] = useState(false);
  const [payrollFlg, setPayrollFlg] = useState(false);
  const [isActive, setIsActive] = useState(true);
  
  // Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [editById, setEditById] = useState("");
  const [editDateFrom, setEditDateFrom] = useState("");
  const [editDateTo, setEditDateTo] = useState("");
  const [editPayTypeId, setEditPayTypeId] = useState("");
  // CHANGED: Initialize as empty string
  const [editIdentifier, setEditIdentifier] = useState("");
  const [editTimeKeepingFlg, setEditTimeKeepingFlg] = useState(false);
  const [editPayrollFlg, setEditPayrollFlg] = useState(false);
  const [editIsActive, setEditIsActive] = useState("");
  
  //Old
  const [oldEditDateFrom, setOldEditDateFrom] = useState("");
  const [oldEditDateTo, setOldEditDateTo] = useState("");
  const [oldEditIsActive, setOldEditIsActive] = useState("");

  const [filterPayTypeId, setFilterPayTypeId] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterIdentifier, setFilterIdentifier] = useState(""); 

  // Request Messages
  const {
    showMessage,
    message,
    isSuccess: isMsgSuccess,
    messageKey,
    showGeneralMessage
  } = useGeneralMessage();

  const apiUrl = domain + "/api/PayrollPeriod";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setPayrollPeriod(response.data);
      setOriginalPayrollPeriod(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let filteredData = originalPayrollPeriod;

    if (filterPayTypeId !== "") {
      filteredData = filteredData.filter(i => i.payTypeId?.toString() === filterPayTypeId.toString());
    }

    if (filterYear) {
      filteredData = filteredData.filter(i => new Date(i.dateFrom).getFullYear().toString() === filterYear || new Date(i.dateTo).getFullYear().toString() === filterYear);
    }

    if (filterStatus) {
      const status = filterStatus === "Active";
      filteredData = filteredData.filter(i => i.isActive === status);
    }
    
    // Filtering logic for Identifier
    if (filterIdentifier !== "") {
        filteredData = filteredData.filter(i => i.identifier === filterIdentifier);
    }

    setPayrollPeriod(filteredData);
  }, [filterPayTypeId, filterYear, filterStatus, filterIdentifier, originalPayrollPeriod]); 

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      payTypeId: payTypeId,
      isActive: isActive,
      timeKeepingFlg: timeKeepingFlg,
      payrollFlg: payrollFlg,
      identifier: identifier, 
    };

    try {
      setLoadingRequest(true);
      const response = await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setShowAddForm(false);
      await SetAuditTrail({
        setupArea: "Payroll Period",
        actionTaken: "add",
        field: "Add",
        newValue: `${response.data.name}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchData();

      console.log('Data added successfully');
      showGeneralMessage("Request Success!", true);

      // Reset fields
      setDateFrom("");
      setDateTo("");
      setPayTypeId("");
      setIdentifier(""); // CHANGED: Reset to empty, not FIRST
      setIsActive(true);
      setTimeKeepingFlg(false);
      setPayrollFlg(false);
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }

    setShowAddForm(false);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      dateFrom: editDateFrom,
      dateTo: editDateTo,
      payTypeId: editPayTypeId,
      isActive: editIsActive,
      timeKeepingFlg: editTimeKeepingFlg,
      payrollFlg: editPayrollFlg,
      identifier: editIdentifier,
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/${editById}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setShowEditForm(false);
      let auditInfo = [];

      if (data.dateFrom !== oldEditDateFrom) {
        auditInfo.push({
          setupArea: "Date From",
          actionTaken: "update",
          field: "Date From",
          newValue: `${data.dateFrom}`,
          oldValue: `${oldEditDateFrom}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (data.dateTo !== oldEditDateTo) {
        auditInfo.push({
          setupArea: "Date To",
          actionTaken: "update",
          field: "Date To",
          newValue: `${data.dateTo}`,
          oldValue: `${oldEditDateTo}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (data.isActive !== oldEditIsActive) {
        auditInfo.push({
          setupArea: "Payroll Period",
          actionTaken: "update",
          field: "Is Active?",
          newValue: `${data.isActive ? "Active" : "InActive"}`,
          oldValue: `${oldEditIsActive ? "Active" : "InActive"}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      await SetAuditTrailBulk({ data: auditInfo });

      await fetchData();

      console.log('Data updated successfully');
      showGeneralMessage("Request Success!", true);

      setEditDateFrom("");
      setEditDateTo("");
      setEditPayTypeId("");
      setEditIdentifier(""); // CHANGED: Reset to empty
      setEditIsActive(false);
      setEditTimeKeepingFlg(false);
      setEditPayrollFlg(false);
      setEditById("");
    } catch (error) {
      console.error('There was a problem updating data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };

  const addHandleClick = () => {
    setIdentifier(""); // CHANGED: Explicitly set to empty so Placeholder shows
    setShowAddForm(true);
  };

  const editHandleClick = (data) => {
    setEditById(data.id);
    setEditDateFrom(data.dateFrom);
    setEditDateTo(data.dateTo);
    setEditPayTypeId(data.payTypeId);
    setEditIdentifier(data.identifier || ""); // CHANGED: Use DB value or empty (not FIRST)
    setEditTimeKeepingFlg(data.timeKeepingFlg);
    setEditPayrollFlg(data.payrollFlg);
    setEditIsActive(data.isActive);
    setOldEditDateFrom(data.dateFrom);
    setOldEditDateTo(data.dateTo);
    setOldEditIsActive(data.isActive);
    setShowEditForm(true);
  };

  const closeAddHandleClick = () => {
    setShowAddForm(false);
    setDateFrom("");
    setDateTo("");
    setPayTypeId("");
    setIdentifier(""); // CHANGED: Reset to empty
    setIsActive(true);
    setTimeKeepingFlg(false);
    setPayrollFlg(false);
  };

  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Payroll >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Payroll Period"}</span>
              </div>
              <h3>Payroll Period</h3>
            </div>
            <div className="mainte-body">
              <div className='filters-payroll'>
                <span>Filter</span>
                <div className="payroll-item-holder info-item-holder row" style={{ justifyContent: "space-evenly", padding: "0 10px 20px 10px" }}>
                  <div className="filter-item-payroll popUp-item info-item column">
                    <div className="info-item-label">Pay Type</div>
                    <div className="info-item-input">
                      <PayTypeIdSelectFilter payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId} />
                    </div>
                  </div>
                  <div className="filter-item-payroll popUp-item info-item column">
                    <div className="info-item-label">Year</div>
                    <div className="info-item-input">
                      <YearSelect year={filterYear} setYear={setFilterYear} payrollPeriod={payrollPeriod} />
                    </div>
                  </div>
                  <div className="filter-item-payroll popUp-item info-item column">
                    <div className="info-item-label">Status</div>
                    <div className="info-item-input">
                      <StatusSelect status={filterStatus} setStatus={setFilterStatus} />
                    </div>
                  </div>
                  {/* Identifier Filter - includeAll={true} to show "All" option */}
                  <div className="filter-item-payroll popUp-item info-item column">
                    <div className="info-item-label">Identifier</div>
                    <div className="info-item-input">
                      <IdentifierSelect 
                        value={filterIdentifier} 
                        setValue={setFilterIdentifier}
                        includeAll={true}
                        darkAllValue={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mainte-body-top row">
                <div className="mainte-addBtn row" style={{ justifyContent: "start" }}>
                  {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                </div>
              </div>
              <div className="maintenance-table container">
                <CreateTable
                  dataList={payrollPeriod}
                  dataHeader={header}
                  dataAccessor={accessor}
                  editHandleClick={editHandleClick}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Form */}
      <AddEditForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        title="Add Payroll Period"
        submitText="SAVE"
        onSubmit={handleSubmit}
        dateFrom={dateFrom}
        dateTo={dateTo}
        payTypeId={payTypeId}
        identifier={identifier} 
        isActive={isActive}
        timeKeepingFlg={timeKeepingFlg}
        payrollFlg={payrollFlg}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setPayTypeId={setPayTypeId}
        setIdentifier={setIdentifier} 
        setIsActive={setIsActive}
        setTimeKeepingFlg={setTimeKeepingFlg}
        setPayrollFlg={setPayrollFlg}
      />

      {/* Edit Form */}
      <AddEditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        title="Update Payroll Period"
        submitText="UPDATE"
        onSubmit={handleUpdate}
        dateFrom={editDateFrom}
        dateTo={editDateTo}
        payTypeId={editPayTypeId}
        editIdentifier={editIdentifier} 
        isActive={editIsActive}
        timeKeepingFlg={editTimeKeepingFlg}
        payrollFlg={editPayrollFlg}
        setDateFrom={setEditDateFrom}
        setDateTo={setEditDateTo}
        setPayTypeId={setEditPayTypeId}
        setEditIdentifier={setEditIdentifier}
        setIsActive={setEditIsActive}
        setTimeKeepingFlg={setEditTimeKeepingFlg}
        setEditPayrollFlg={setEditPayrollFlg}
      />

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isMsgSuccess}
        key={messageKey}
      />

      <LoadingSpinner loading={loadingRequest || loading} />
    </div>
  )
}

function AddEditForm({
  isOpen,
  onClose,
  title,
  submitText,
  onSubmit,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  payTypeId, setPayTypeId,
  isActive, setIsActive,
  timeKeepingFlg, setTimeKeepingFlg,
  payrollFlg, setPayrollFlg,
  identifier, setIdentifier,
  editIdentifier, setEditIdentifier
}) {
  const [errorState, setErrorState] = useState(false);

  const isEditing = editIdentifier !== undefined;
  const currentIdentifier = isEditing ? editIdentifier : identifier;
  const setCurrentIdentifier = isEditing ? setEditIdentifier : setIdentifier;

  const submit = (e) => {
    // Validation: checks if currentIdentifier is empty/null
    if (!dateFrom || !dateTo || !payTypeId ) {
      setErrorState(true);
      return;
    }
    onSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setErrorState(false);
  };

  const handleIsActiveChange = (event) => {
    setIsActive(event.target.checked);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{title}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Pay Type</div>
                <div className="info-item-input">
                  <PayTypeSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId} />
                </div>
                <span style={{
                  visibility: !payTypeId && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>

              {/* Identifier Field in Form */}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Identifier</div>
                <div className="info-item-input">
                  <IdentifierSelect
                    value={currentIdentifier || ""}
                    setValue={setCurrentIdentifier}
                    allowNone={true}
                  />
                </div>
                <span style={{
                  visibility: !currentIdentifier && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>

              <div className="popUp-item info-item column">
                <div className="info-item-label">Date From</div>
                <div className="info-item-input">
                  <DateTimeInput date={dateFrom} setDate={setDateFrom} />
                </div>
                <span style={{
                  visibility: !dateFrom && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Date To</div>
                <div className="info-item-input">
                  <DateTimeInput date={dateTo} setDate={setDateTo} />
                </div>
                <span style={{
                  visibility: !dateTo && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isActive}
                    onChange={(e) => handleIsActiveChange(e)} />
                </div>
              </div>
              {/* <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Posted Time Keeping?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={timeKeepingFlg}
                    onChange={(e) => setTimeKeepingFlg(e.target.checked)} />
                </div>
              </div>
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Posted Payroll?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={payrollFlg}
                    onChange={(e) => setPayrollFlg(e.target.checked)} />
                </div>
              </div> */}
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                {submitText}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}


function PayTypeIdSelectFilter({ payTypeId, setPayTypeId }) {
  const handleSelectChange = (event) => {
    setPayTypeId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/PayType/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      }
    })
      .then(response => {
        setData(response.data); 
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={payTypeId || ""} onChange={handleSelectChange} style={{ color: "rgb(104, 104, 104)" }}>
        <option value="">All</option>
        {data.map((payTypeId) => (
          SetPayTypeId(payTypeId)
        ))}
      </select>
    </div>
  );
};

function SetPayTypeId(payTypeId) {
  return (
    <option key={payTypeId.id} value={payTypeId.id}>{
      payTypeId.description}
    </option>
  )
}

export default PayrollPeriod;